import {
  SETTINGS_SAVED,
  SETTINGS_PAGE_UNLOADED,
  ASYNC_START,
  RATES_PAGE_LOADED,
  RATES_PAGE_UNLOADED,
  RATE_CREATE_PAGE_LOADED,
  RATE_CREATE,
  RATE_CREATE_PAGE_UNLOADED,
  RATE_UPDATE_PAGE_LOADED,
  RATE_UPDATE,
  RATE_UPDATE_PAGE_UNLOADED
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case SETTINGS_SAVED:
      return {
        ...state,
        inProgress: false,
        errors: action.error ? action.payload.errors : null
      };
    case RATES_PAGE_LOADED:
      return {
        ...state,
        rates: action.payload.rates,
      };
    case RATE_UPDATE_PAGE_LOADED:
      return {
        ...state,
        rate: action.payload.rate,
      };
    case RATE_CREATE:
    case RATE_UPDATE:
      return {
        ...state,
        inProgress: false,
        errors: action.error ? action.payload.error : null,
        rate: action.error ? null : action.payload.rate
      };
    case SETTINGS_PAGE_UNLOADED:
    case RATES_PAGE_UNLOADED:
    case RATE_CREATE_PAGE_UNLOADED:
    case RATE_UPDATE_PAGE_UNLOADED:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/settings.js